<template lang="pug">
component(:is='props.tag' :class='computedClasses')
  slot
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type HeadingProps } from './Heading.types';
import { headingDefaults } from './Heading.defaults';

const props = withDefaults(defineProps<HeadingProps>(), headingDefaults);

const computedClasses = computed(() => {
  const classes = [];

  // Add size
  classes.push(`h${props.size}`);

  // Add Bootstrap text color class
  if (props.context !== 'none') {
    classes.push(`text-${props.context}`);
  }

  return classes;
});
</script>
